import React from 'react';
import styled from '@emotion/styled';
import Img01 from 'ui/images/top/topService_img01@2x.png';
import Img02 from 'ui/images/top_for_buyer/pc_illustration.svg';
import Img03 from 'ui/images/top/topService_img04@2x.png';
import Img04 from 'ui/images/top/topService_img03@2x.png';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--white);
    padding: 61px 0 30px 0;

    img {
        display: block;
        max-width: 100%;
    }

    ${mqMin('NARROW')} {
        padding: 5rem 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    font-size: 1.589rem;
    margin-bottom: 2rem;

    ${mqMin('SP')} {
        font-size: 2rem;
    }

    ${mqMin('NARROW')} {
        font-size: 1.6rem;
    }
`;

const DescriptionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
    width: 17.027rem;
    margin: 0 auto;

    ${mqMin('SP')} {
        width: 34.027rem;
        gap: 1rem;
    }

    ${mqMin('NARROW')} {
        gap: initial;
        width: 70rem;
        max-width: 1260px;
    }
`;

const DescriptionItem = styled.div`
    width: 100%;
    background-color: #fbf1e5;
    border-radius: 8px;
    padding: 1.5rem 0;
    gap: 0.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transform: translateY(30px);
    transition: transform 1s cubic-bezier(0.25, 1, 0.5, 1), opacity 1s cubic-bezier(0.25, 1, 0.5, 1);

    ${mqMin('SP')} {
        width: 48%;
    }

    ${mqMin('NARROW')} {
        width: 16.7rem;
        max-width: 300px;
    }

    span {
        font-size: 0.778rem;
        font-weight: 500;
        text-align: center;
        line-height: 1.6;
    }
`;

const ImgContainer = styled.div`
    height: 115px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ImgItem1 = styled.img`
    width: 7.278rem;
    height: auto;
`;

const ImgItem2 = styled.img`
    width: 6.222rem;
    height: auto;
`;

const ImgItem3 = styled.img`
    width: 8.389rem;
    height: auto;
`;

const ImgItem4 = styled.img`
    width: 8.389rem;
    height: auto;
`;

const H3 = styled.h3`
    text-align: center;

    &::after {
        content: '';
        display: block;
        width: 1.52rem;
        height: 2px;
        background-color: var(--dark-blue);
        margin: 8px auto;
    }

    ${mqMin('SP')} {
        font-size: 1.2rem;
    }

    ${mqMin('NARROW')} {
        font-size: 0.778rem;
    }
`;

const Text = styled.p`
    padding: 0 15px;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.6em;
    letter-spacing: 0.1em;

    ${mqMin('NARROW')} {
        font-size: 1rem;
    }
`;

export const AboutService: React.FC = () => {
    return (
        <Container id="about-service">
            <H2 className="fadein fadein_y">MAnyサービスの流れ</H2>
            <DescriptionContainer className="fadeinLi">
                <DescriptionItem>
                    <H3>STEP01</H3>
                    <ImgContainer>
                        <ImgItem1 src={Img01} alt="STEP1のイメージ" />
                    </ImgContainer>
                    <Text>
                        M&Aでの買収希望案件条件を <br />
                        登録＆投稿
                    </Text>
                    <span>
                        ※投稿時は匿名となるため、
                        <br />
                        貴社名は公開されません
                    </span>
                </DescriptionItem>
                <DescriptionItem>
                    <H3>STEP02</H3>
                    <ImgContainer>
                        <ImgItem2 src={Img02} alt="STEP2のイメージ" />
                    </ImgContainer>
                    <Text>
                        貴社へ提案希望の
                        <br />
                        仲介会社からオファー
                    </Text>
                    <span>
                        希望に合致した案件を担当する
                        <br />
                        仲介会社などから来ます
                    </span>
                </DescriptionItem>
                <DescriptionItem>
                    <H3>STEP03</H3>
                    <ImgContainer>
                        <ImgItem3 src={Img03} alt="STEP3のイメージ" />
                    </ImgContainer>
                    <Text>
                        オファーを了承すると、
                        <br />
                        個別チャットが開設
                    </Text>
                    <span>
                        了承相手にのみ
                        <br />
                        貴社名が公開されます
                    </span>
                </DescriptionItem>
                <DescriptionItem>
                    <H3>STEP04</H3>
                    <ImgContainer>
                        <ImgItem4 src={Img04} alt="STEP4のイメージ" />
                    </ImgContainer>
                    <Text>
                        仲介会社を
                        <br />
                        比較・検討する
                    </Text>
                    <span>
                        理想の仲介会社を
                        <br />
                        探しましょう！
                    </span>
                </DescriptionItem>
            </DescriptionContainer>
        </Container>
    );
};
